/**
 * Calculates the interest saved based on overpayment variable
 *
 * @param {number} remainingBalance Remaining balance in pence
 * @param {number} monthlyPayment Monthly payment in pence
 * @param {number} overpaymentAmount
 * @param {number} overpaymentInterval
 * @param {number} interestRate Interest rate as a float
 *
 * @return {number} Interest saved in pence
 *
 */

import getRemainingTerm from './getRemainingTerm';
import getTotalInterest from './getTotalInterest';

const getInterestSaved = (args) => {
  // Check arguments
  if (!args.remainingBalance && args.remainingBalance !== 0)
    throw new Error('Remaining balance is required');
  if (!args.monthlyPayment && args.monthlyPayment !== 0)
    throw new Error('Monthly payment is required');
  if (!args.overpaymentAmount && args.overpaymentAmount !== 0)
    throw new Error('Overpayment amount is required');
  if (!args.overpaymentInterval && args.overpaymentInterval !== 0)
    throw new Error('Overpayment interval is required');
  if (!args.interestRate && args.remainingBalance !== 0)
    throw new Error('Interest rate is required');

  const {
    remainingBalance,
    monthlyPayment,
    overpaymentAmount,
    overpaymentInterval,
    interestRate,
  } = args;

  const originalTerm = getRemainingTerm({
    remainingBalance,
    monthlyPayment,
    interestRate,
  });

  const newTerm = getRemainingTerm({
    remainingBalance,
    monthlyPayment,
    overpaymentAmount,
    overpaymentInterval,
    interestRate,
  });

  const monthlyWithOverpayment =
    overpaymentInterval === 'monthly'
      ? monthlyPayment + overpaymentAmount
      : monthlyPayment;

  const balanceWithOverpayment =
    overpaymentInterval === 'monthly'
      ? remainingBalance
      : remainingBalance - overpaymentAmount;

  const currentInterest = getTotalInterest({
    remainingTerm: originalTerm,
    monthlyPayment,
    remainingBalance,
  });

  const scenarioInterest = getTotalInterest({
    remainingTerm: newTerm,
    monthlyPayment: monthlyWithOverpayment,
    remainingBalance: balanceWithOverpayment,
  });

  return currentInterest - scenarioInterest;
};

export default getInterestSaved;
